export default {
  setWorkPosition(state, value) {
    state.workPosition = value
  },
  setWorkPositions(state, value) {
    state.workPositions = value
  },
  setWorkPositionFilters(state, value) {
    state.workPositionFilters = value
  },
  setWorkPositionSalaryField(state, obj) {
    if (Array.isArray(state.workPosition.salary_base)) {
      state.workPosition.salary_base = {}
    }
    if (state.workPosition) {
      state.workPosition.salary_base[obj.key] = obj.value
    }
  },
  setWorkPositionField(state, obj) {
    if (state.workPosition) {
      state.workPosition[obj.key] = obj.value
    }
  },
  setWorkPositionPermission(state, obj) {
    state.workPosition.permissions.push(obj)
  },

  removeWorkPositionPermission(state, obj) {
    state.workPosition.permissions = state.workPosition.permissions.filter(
      item => item.permission_id != obj.permission_id,
    )
  },

  setWorkPositionErrors(state, workPositionErrors) {
    state.workPositionErrors = workPositionErrors
  },
  unshiftWorkPositions(state, workPosition) {
    state.workPositions.unshift(workPosition)
  },
  changeWorkPosition(state, payload) {
    for (let i = 0; i < state.workPositions.length; i++) {
      if (state.workPositions[i].id === payload.key) {
        const item = _.cloneDeep(payload.value)
        state.workPositions.splice(i, 1, item)
        break
      }
    }
  },
  deleteWorkPosition(state, id) {
    for (let i = 0; i < state.workPositions.length; i++) {
      if (state.workPositions[i].id === id) {
        state.workPositions.splice(i, 1)
        break
      }
    }
  },
  setWorkPositionsTypes(state, data) {
    state.workPositionsTypes = data
  },
}
